
export const webAccordionData = [
    { label: "• Terms and Conditions", path: "/terms-and-Conditions" },
    { label: "• Privacy Policy", path: "/privacy-policy" },
    { label: "• Community Guidelines", path: "/community-guidelines" },
    { label: "• Cookies", path: "/cookies" },
    { label: "• Security", path: "/security" },
    { label: "• Blog", path: "/blog" },
    { label: "• Press", path: "/press" },
    { label: "• FAQ", path: "/FAQ" },
    { label: "• Careers", path: "/careers" },
    { label: "• Learning", path: "/learning" },
];

export const adminDashboardRoutes = [
    { label: "• Dashboard", path: "/dashboard" },
    { label: "• Fleet Owner", path: "/fleet-owner-dashboard" },
    { label: "• Bus Operator", path: "/bus-operator-dashboard" },
    { label: "• Restaurant", path: "/restaurant-dashboard" },
    { label: "• Sales Agent", path: "/sales-agent-dashboard" },
    { label: "• Rides", path: "/rides-dashboard" },
    {
        label: "• Car Rentals",
        path: "/car-rentals-dashboard",
    },
    { label: "• Yiino Business", path: "/yiino-business-dashboard" },

]
